import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EncryptionService } from './encryption.service';
import { AppEnum } from '../appenum';
import * as CryptoJS from 'crypto-js';
import { AppService } from './app.service';
import { wrapAllMethodsWithLogging } from '../core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';
@Injectable({
  providedIn: 'root'
})
export class CustomTranslateService implements TranslateLoader {
  secretKeyForDataEnc = "xT46emMu7wJpsQGe";  //key used in Python
  secretIVKeyForDataEnc = "U3U9lKwOGNTk0Rz8";
  public apiUrl = `${environment.apiUrl}`;
  private _appServiceInstance: AppService
  componentName: string = 'custom-translate';
  constructor(private http: HttpClient, public encryptionService: EncryptionService, public _appenum: AppEnum,
    // private appService: AppService
    private injector: Injector
  ) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
  }
  private get appService(): AppService {
    if (!this._appServiceInstance) {
      this._appServiceInstance = this.injector.get(AppService);
    }
    return this._appServiceInstance;
  }

  initLangSubscription(): void {
    const langLoading$ = this.appService?.isLangDataLoading;
    if (!langLoading$) {
      console.warn('isLangDataLoading is not initialized');
      return;
    }

    langLoading$.subscribe((res: boolean) => {
      if (!res) return;
      console.log("res", res)
      const orgId = this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(
          this._appenum.EntityOfLocalStorageKeys.OrgId
        )
      );

      const lang = this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(
          this._appenum.EntityOfLocalStorageKeys.siteLocale
        )
      );
      if (orgId && lang) {
        this.getTranslation(lang).subscribe();
      }
    });
  }

  getTranslation(lang: string): Observable<any> {
    let postJson = {
      orgId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.OrgId)),
      languageCode: lang
    }
    const encryptedPayload = { data: this.encryptDataValues(JSON.stringify(postJson)) };
    return this.http.post(this.apiUrl + 'v2/getLangData', encryptedPayload).pipe(map((results: any) => {
      let jsonData: any = this.decryptDataValues(results?.data)
      return jsonData.Data[0]?.languageJson
    }, (err: { Message: any; }) => {

    }))
  }

  encryptDataValues(data) {
    var key = CryptoJS.enc.Utf8.parse(this.secretKeyForDataEnc);
    var iv = CryptoJS.enc.Utf8.parse(this.secretIVKeyForDataEnc)
    var encrypted: any = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC });
    encrypted = encrypted.toString();
    return encrypted.toString();
  }

  decryptDataValues(Base64CBC) {
    var iv = CryptoJS.enc.Utf8.parse(this.secretIVKeyForDataEnc);
    var key = CryptoJS.enc.Utf8.parse(this.secretKeyForDataEnc);
    var decrypted: any = CryptoJS.AES.decrypt(Base64CBC, key, { iv: iv, mode: CryptoJS.mode.CBC });
    decrypted = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  }
}
